import {RedeemManager} from "@/Core/Redeem/RedeemManager";
import Util from "@/Master/Util";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import {comRequest} from "@/Fwk/Http/comRequest";
import RequestMgr from "@/Fwk/Http/RequestMgr";
import {confJson} from "@/app/config/confJson";
import {isEmpty} from "@/app/utils/tool";
import {getUserId} from "@/app/utils/auth";
import {NetType} from "@/Fwk/Http/NetType";


export default class WebRedeem {
    public static Instance = new WebRedeem();
    private isRequesting: boolean = false;

    //请求兑换订单
    public async RequestRedeemApply(sendData: RequestRedeemApplyData, onFinish?: (data: HttpResponse<ResponseRedeemApplyData>)=>void) {
        if (this.isRequesting) return;
        if (Util.isLog) {
            console.log(RedeemManager.tag, `兑换数据:${sendData}`)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemApplyDirect),
            method: 'POST',
            body: sendData,
        };
        const response = await this.DoSendRequest<ResponseRedeemApplyData>(config);
        onFinish?.(response);
        return response;
    }


    // 请求兑换取消
    public async RequestRedeemCancel(orderId: string, onFinish: (data: HttpResponse<ResponseRedeemCancelData>)=>void) {
        if (this.isRequesting) return;
        if (isEmpty(orderId)) return;
        let sendData = {} as RequestRedeemCancelData;
        sendData.orderId = orderId;
        sendData.userId = LoginUIManager.getLastUserId+'';
        sendData.productId = confJson.productId.toString();
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求兑换取消:${sendData}`)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemCancel),
            method: 'POST',
            body: sendData,
        };
        const response = await this.DoSendRequest<ResponseRedeemCancelData>(config);
        onFinish(response);
    }


    // 请求兑换渠道校验
    public async RequestRedeemChannelCheck(payType: number, onFinish: (data: HttpResponse<ResponseRedeemChannelCheckData>)=>void) {
        if (this.isRequesting) return;
        let sendData = {} as RequestRedeemChannelCheckData;
        sendData.channelType = payType;
        sendData.userId = LoginUIManager.getLastUserId;
        sendData.productId = confJson.productId;
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求兑换校验:${sendData}`)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemChannelCheck),
            method: 'POST',
            body: sendData,
        };
        const response = await this.DoSendRequest<ResponseRedeemChannelCheckData>(config);
        // const responseData = response.data;
        onFinish(response);
        return response;
    }


    // 请求兑换通用校验
    public async RequestRedeemCheck(payType: number, onFinish?: (data: HttpResponse<ResponseRedeemCheckData>)=>void) {
        if (this.isRequesting) return;
        let sendData = {} as RequestRedeemCheckData;
        sendData.channelType = payType;
        sendData.userId = LoginUIManager.getLastUserId;
        sendData.productId = confJson.productId;
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求兑换校验:${sendData}`)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemNewCheck),
            method: 'POST',
            body: sendData,
        };
        const response = await this.DoSendRequest<ResponseRedeemCheckData>(config);
        // const responseData = response.data;
        onFinish?.(response);
        return response;
    }

    // 请求兑换订单列表
    public async RequestRedeemOrderList(page: number,pageSize: number, onFinish: (data: ResponseRedeemOrderListData)=>void) {
        if (this.isRequesting) return;
        let sendData = {} as RequestRedeemOrderListData;
        // sendData._orderBy = '1';
        sendData.userId = getUserId();
        sendData.pageNum = page;
        sendData.pageSize = pageSize;
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求兑换订单列表:`,sendData)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemOrderList),
            method: 'POST',
            body: sendData,
        };
        const response = await this.DoSendRequest<ResponseRedeemOrderListData>(config);
        const responseData = response.data;
        if (response.code == 200 && responseData ){
            onFinish(responseData);
        }else{
            onFinish(responseData);
        }

        return response;
    }


    // 请求兑换配置
    public async RequestRedeemConfig(onFinish: (data: ResponseRedeemConfigData[]) => void) {
        if (this.isRequesting) return;
        let sendData = {} as RequestRedeemConfigData;
        sendData.apiVersion = '2';
        sendData.userId = LoginUIManager.getLastUserId+'';
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求兑换订单列表:`,sendData)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemConfig),
            method: 'POST',
            body: sendData,
            // headers: {Authorization: LoginNetManager.Instance.getLoginToken+''},
        };
        const response = await this.DoSendRequest<ResponseRedeemConfigData[]>(config);
        const responseData = response.data;
        onFinish(responseData);
    }

    //请求银行卡的信息
    public async RequestBindGetCardInfo(channelType: number, onFinish?: (data: ResponseRedeemBindGetCardsData)=>void) {
        if (this.isRequesting) return;
        let sendData = {} as RequestRedeemBindGetCardsData;
        sendData.userId = getUserId();
        sendData.channelType = channelType;
        // sendData.orderNo = orderNo;
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求银行卡的信息:`,sendData)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemGetBindCardsInfo),
            method: 'POST',
            body: sendData,
        };
        const response = await this.DoSendRequest<ResponseRedeemBindGetCardsData>(config);
        const responseData = response.data;
        if (response.code == 200 && responseData ){
            onFinish?.(responseData);
        }else{
            onFinish?.(responseData);
        }
        return response;
    }

    //请求银行卡链接地址
    public async RequestBindGetCardsLink(channelType: number, onFinish?: (data: ResponseRedeemBindGetCardLinksData) => void) {
        if (this.isRequesting) return;
        let sendData = {} as RequestRedeemBindGetCardsLinkData;
        sendData.userId = getUserId();
        sendData.channelType = channelType;
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求银行卡的信息:`,sendData)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemGetBindCardsLink),
            method: 'POST',
            body: sendData,
        };
        const response = await this.DoSendRequest<ResponseRedeemBindGetCardLinksData>(config);
        const responseData = response.data;
        if (response.code == 200 && responseData ){
            onFinish?.(responseData);
        }else{
            onFinish?.(responseData);
        }
        return response;
    }

    //请求绑定渠道的提现帐号信息
    public async RequestBindWithdrawAccount(sendData: RequestBindWithdrawAccountData, onFinish?: (data: ResponseBindWithdrawAccountData)=>void) {
        if (this.isRequesting) return;
        if (Util.isLog) {
            console.log(RedeemManager.tag, `请求绑定渠道提现帐号信息:`,sendData)
        }
        const config: HttpConfig = {
            url: RequestMgr.getUrl(NetType.RedeemBindAccount),
            method: 'POST',
            body: sendData,
        };
        const response = await this.DoSendRequest<ResponseBindWithdrawAccountData>(config);
        const responseData = response.data;
        if (response.code == 200 && responseData ){
            onFinish?.(responseData);
        }else{
            onFinish?.(responseData);
        }
        return response;
    }



    public async DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
        this.isRequesting = true;
        config.isSerErrTips = true;
        const sendRequest = await comRequest<T>(config);
        this.isRequesting = false;
        return sendRequest;
    }



}

